module.exports = __webpack_public_path__ + "static/media/6.5ffbc1a5.jpg";